import http from 'hub-http/clients/apiClient';
const BASE_URL_FORMS = 'forms/app/v1/form-actions/permissions';
const deleteFormPermissions = formGuids => {
  return http.post(`${BASE_URL_FORMS}/batch/purge`, {
    data: {
      inputs: formGuids.map(id => ({
        id
      }))
    }
  });
};
export default deleteFormPermissions;